export enum FeatureFlag {
  RADAR = 'RADAR',
  RADAR_DETECT_ENDPOINTS = 'RADAR_DETECT_ENDPOINTS',
  RADAR_DETECT_ENDPOINT_PAYLOAD = 'RADAR_DETECT_ENDPOINT_PAYLOAD',
  RADAR_DEPENDENCIES = 'RADAR_DEPENDENCIES',
  ISSUES = 'ISSUES',
  ASSISTANT = 'ASSISTANT',
  DEBUG_SESSION = 'DEBUG_SESSION',
  FLOWS = 'FLOWS',
  SKETCH = 'SKETCH',
  NOTEBOOK = 'NOTEBOOK',
  REPOSITORY = 'REPOSITORY',
  PLATFORM = 'PLATFORM',
  VARIABLE_GROUP = 'VARIABLE_GROUP',
  PROJECT_BRANCH = 'PROJECT_BRANCH',
  END_USERS = 'END_USERS',
  ALERT_RULES = 'ALERT_RULES',
  CONDITIONAL_RECORDING = 'CONDITIONAL_RECORDING',
  AGENTS = 'AGENTS',
}
